// src/features/seec/utils/componentsUtils.js

/**
 * Safely converts various date-like inputs into a JavaScript Date.
 *
 * Supported inputs:
 * - Firestore Timestamp (has .toDate())
 * - JavaScript Date
 * - ISO date string
 * - numeric timestamp
 *
 * @param {*} value
 * @returns {Date|null}
 */
export function toJSDate(value) {
  if (!value) return null;

  // Firestore Timestamp
  if (typeof value?.toDate === "function") {
    const d = value.toDate();
    return d instanceof Date && !Number.isNaN(d.getTime()) ? d : null;
  }

  // Already a Date
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  // String / number -> Date
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

/**
 * Formats a Date as MM/DD/YYYY for table display.
 *
 * @param {Date|null} date
 * @returns {string}
 */
export function formatMMDDYYYY(date) {
  if (!(date instanceof Date)) return "—";
  return date.toLocaleDateString("en-US");
}
